import React, { Component } from "react";
import { Route, NavLink, Link, Routes } from "react-router-dom";
import { withRouter, RenderRoute } from "../../utils/router";
import { withRequest } from "../../utils/request";
import Edit from "./Edit";
import Produccion from "./Produccion";
import Servicios from "./Servicios/";
import Gastos from "./Gastos";
import { getLink } from "../../utils/helpers";

class LayoutVehiculo extends Component {
    state = {
        vehiculo: {},
        categorias: [],
        choferes: [],
    };
    componentDidMount() {
        this.getCategorias();
        this.getVehiculo();
        this.getChoferes();
    }
    getCategorias = async (url = null) => {
        url = url ? url : "categorias";
        const categorias = await this.props.request(url);

        if (categorias.links) {
            this.setState({
                categorias: categorias.data,
            });
        }
    };
    getChoferes = async (url = null) => {
        url = url ? url : "empleados?choferes=1";
        const choferes = await this.props.request(url);

        if (choferes.data) {
            this.setState({
                choferes: choferes.data,
            });
        }
    };
    getVehiculo = async (url = null) => {
        const id = this.props.match.params.id;
        url = url ? url : "vehiculos/" + id;
        const vehiculo = await this.props.request(url);

        if (vehiculo.success) {
            this.setState({
                vehiculo: vehiculo.data,
            });
        }
    };
    render() {
        const { vehiculo, choferes, categorias } = this.state;
        return (
            <div>
                <div className='page-header'>
                    <Link to={getLink('/vehiculos/')}>&laquo; Volver a vehículos</Link>
                    <h1 className='page-title'>Editar {vehiculo.ficha}</h1>
                </div>
                <div className='row'>
                    <div className='col page-sidebar'>
                        <ul className='list-unstyled page-sidebar__menu'>
                            <li>
                                <NavLink
                                    to={getLink(
                                        `/vehiculos/${vehiculo.id}/informacion`
                                    )}
                                    end
                                    className='nav-link'>
                                    Información General
                                </NavLink>
                                <NavLink
                                    to={getLink(
                                        `/vehiculos/${vehiculo.id}/gastos`
                                    )}
                                    end
                                    className='nav-link'>
                                    Historial de Gastos
                                </NavLink>
                                <NavLink
                                    to={getLink(
                                        `/vehiculos/${vehiculo.id}/produccion`
                                    )}
                                    end
                                    className='nav-link'>
                                    Producción
                                </NavLink>
                                <NavLink
                                    to={getLink(
                                        `/vehiculos/${vehiculo.id}/servicios`
                                    )}
                                    end
                                    className='nav-link'>
                                    Servicios
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className='col-md-9 p-l-50'>
                        <Routes>
                            <Route
                                path='informacion'
                                element={<RenderRoute render={(props) => (
                                    <Edit
                                        {...props}
                                        vehiculo={vehiculo}
                                        categorias={categorias}
                                        getVehiculo={this.getVehiculo}
                                        choferes={choferes}
                                    />
                                )} />}
                            />
                            <Route
                                path='gastos'
                                element={<RenderRoute render={(props) => (
                                    <Gastos {...props} vehiculo={vehiculo} />
                                )} />}
                            />
                            <Route
                                path='produccion'
                                element={<RenderRoute render={(props) => (
                                    <Produccion {...props} vehiculo={vehiculo} />
                                )} />}
                            />
                            <Route
                                path='servicios'
                                element={<RenderRoute render={(props) => (
                                    <Servicios {...props} vehiculo={vehiculo} />
                                )} />}
                            />
                        </Routes>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(withRequest(LayoutVehiculo));
